import React, { useEffect, useState } from "react";
import CorporateManagement from "../api/Corporate/CorporateManagement";
import { useLocation } from "react-router-dom";
import {
  setCorporateLogo,
  setCorporateName,
  setCorporateDetail,
  BASE_URL_MEDIA,
} from "../api/Constants";

const CorporateStyles = () => {
  const [loading, setLoading] = useState(false);
  const corporateIdentifier =
    localStorage.getItem("corporate_identifier") || "";
  const [corporateDetails, setCorporateDetails] = useState({});
  const metaToken = localStorage.getItem("metatoken");
  const accountType = localStorage.getItem("accountType");
  const location = useLocation();

  let observer;

  useEffect(() => {
    if (metaToken && corporateIdentifier) {
      getCorporate();
    }
  }, [metaToken]);

  // API call to fetch corporate details
  const getCorporate = async () => {
    setLoading(true);
    try {
      const result = await CorporateManagement.getCorporate(
        corporateIdentifier
      );
      if (result?.status === 200) {
        const data = result?.data?.data;
        setCorporateDetails(data);

        // Save corporate logo and name for footer updates
        localStorage.setItem("corporateLogo", data?.logo);
        setCorporateLogo(data?.logo);
        setCorporateName(data?.name);
        setCorporateDetail(data);

        // Update favicon and document title
        if (data?.name) document.title = data?.name;
        if (data?.logo) {
          const favicon = document.querySelector('link[rel="icon"]');
          if (favicon) {
            favicon.href = `${BASE_URL_MEDIA}/apis/storage/assets/uploads/${data?.logo}`;
          }
        }

        // Save trial information for corporate admin
        if (accountType === "corporate_admin") {
          localStorage.setItem("trial_start_date", data?.trial_start_date);
          localStorage.setItem("trial_period", data?.trial_period);
        }
        setLoading(false);
      } else {
        setLoading(false);
        console.error(result?.data?.message);
      }
    } catch (error) {
      console.error(error?.result?.data?.errors[0]);
      setLoading(false);
    }
  };

  // Observe for lazy-loaded elements and dynamically apply styles
  useEffect(() => {
    if (
      corporateDetails &&
      typeof corporateDetails === "object" &&
      Object.keys(corporateDetails).length > 0
    ) {
      updateBgColors();
      updateButtonColors();

      observer = new MutationObserver(() => {
        updateBgColors(); // Apply styles to background elements
        updateButtonColors(); // Apply styles to buttons
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return () => {
        if (observer) observer.disconnect();
      };
    }
  }, [corporateDetails, location.pathname]);

  // Function to update background colors dynamically
  const updateBgColors = () => {
    const elements = [
      {
        element: document.querySelector(".sidebar"),
        bg: corporateDetails?.bg_color,
        text: corporateDetails?.text_color,
      },
      {
        element: document.querySelector(".logo-section"),
        bg: corporateDetails?.bg_color,
        text: corporateDetails?.text_color,
      },
      {
        element: document.querySelector(".main-footer"),
        bg: corporateDetails?.bg_color,
        text: corporateDetails?.text_color,
      },
      {
        element: document.querySelector(".show-on-mobile .filters-section ul"),
        bg: corporateDetails?.bg_color,
        text: corporateDetails?.text_color,
      },
      {
        element: document.querySelector(".events-page"),
        bg: corporateDetails?.bg_color,
        text: corporateDetails?.text_color,
      },
      {
        element: document.querySelector(".home-page"),
        bg: corporateDetails?.bg_color,
        text: corporateDetails?.text_color,
      },
      {
        element: document.querySelector(".communities-page"),
        bg: corporateDetails?.bg_color,
        text: corporateDetails?.text_color,
      },
    ];

    elements.forEach(({ element, bg, text }) => {
      if (element) {
        newBackground(element, bg, text);
      }
    });

    const specificElement = document.querySelector(
      ".reverse-dir.col-12.col-md-9"
    );
    if (specificElement) {
      specificElement.style.background = "white";
    }
  };

  // Function to update button colors dynamically
  const updateButtonColors = () => {
    const buttonCollections = [
      ...document.getElementsByClassName("button"),
      ...document.getElementsByClassName("alert-modal-yes"),
      ...document.getElementsByClassName("approve"),
      ...document.getElementsByClassName("no-list"),
      ...document.querySelectorAll(".steps ul li.active .number"),
      ...document.querySelectorAll(".private-input-wrapper button"),
      ...document.querySelectorAll(".nav-buttons button"),
      ...document.querySelectorAll(".view"),
      ...document.querySelectorAll(".diet-filters .navigation-link.active"),
    ];

    buttonCollections.forEach((button) => {
      newBackground(
        button,
        corporateDetails?.button_color,
        corporateDetails?.text_color
      );
    });
  };

  const newBackground = (element, bgColor, textColor) => {
    if (!element) {
      console.log(
        "Element not found on the page while updating styles in function newBackground"
      );
      return;
    }
    element.style.setProperty("background", bgColor, "important");
    element.style.setProperty("color", textColor, "important");
  };

  return (
    <>
      {loading && (
        <div className="loader-parent">
          <div className="_loader"></div>
        </div>
      )}
    </>
  );
};

export default CorporateStyles;
